var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MyInvoices',_vm._b({},'MyInvoices',_vm.textContent,false))
}
var staticRenderFns = []

export { render, staticRenderFns }